"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipLabel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _ursaConstants = require("../../typography/constants/ursaConstants");
var _ChipLabelStyled = require("../styled/ChipLabelStyled");
const chipLabelTypeRampTheme = {
  medium: "Inter--12px--600w",
  small: "Inter--12px--600w",
  xsmall: "Inter--12px--600w"
};
const ChipLabel = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    omitTooltip,
    size
  } = _ref;
  const ursaVariant = _ursaConstants.ursaTypeRampDefinitions[chipLabelTypeRampTheme[size]];
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_ChipLabelStyled.ChipLabelStyled
  // Lodestar and Ursa Chips both use the same font styles.
  , (0, _extends2.default)({
    system: "ursa",
    variant: chipLabelTypeRampTheme[size],
    omitTooltip: omitTooltip,
    lineClamp: 1,
    ref: ref,
    themeMode: themeMode,
    chipSize: size
  }, ursaVariant), children);
});
exports.ChipLabel = ChipLabel;
ChipLabel.displayName = "ChipLabel";
//# sourceMappingURL=ChipLabel.js.map